import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { fetchTenenciasByDpi, fetchTenenciasBySerie, deleteTenencia } from '../../../services/modules/Tenencias'; // Importar los servicios necesarios

const ImprimirTenencias = () => {
  const [searchType, setSearchType] = useState('dpi'); // 'dpi' o 'serie'
  const [searchValue, setSearchValue] = useState('');
  const [results, setResults] = useState([]);

  const handleSearch = async () => {
    try {
      const data =
        searchType === 'dpi'
          ? await fetchTenenciasByDpi(searchValue)
          : await fetchTenenciasBySerie(searchValue);
      setResults(data);
    } catch (error) {
      console.error('Error al buscar tenencias:', error);
      alert('Ocurrió un error al buscar las tenencias.');
    }
  };

  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      alert('No se pudo descargar el archivo.');
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar esta tenencia?');
    if (!confirmDelete) return;

    try {
        await deleteTenencia(id); // Llama al servicio con el ID
        setResults(results.filter((tenencia) => tenencia.id !== id)); // Filtra las tenencias eliminadas
        alert('Tenencia eliminada con éxito.');
    } catch (error) {
        console.error('Error al eliminar la tenencia:', error);
        alert('No se pudo eliminar la tenencia.');
    }
};

  return (
    <Container maxWidth="lg" sx={{ marginTop: '30px' }}>
      <Paper elevation={3} sx={{ padding: '20px' }}>
        <Typography variant="h4" align="center" gutterBottom>
          Imprimir Tenencias
        </Typography>
        <Box
          component="form"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            marginBottom: '20px',
          }}
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <TextField
            label={`Buscar por ${searchType === 'dpi' ? 'DPI' : 'Serie'}`}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            fullWidth
            required
          />
          <Button variant="contained" color="primary" type="submit">
            Buscar
          </Button>
          <Button
            variant="outlined"
            onClick={() => setSearchType(searchType === 'dpi' ? 'serie' : 'dpi')}
          >
            Buscar por {searchType === 'dpi' ? 'Serie' : 'DPI'}
          </Button>
        </Box>

        {results.length > 0 && (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Serie</TableCell>
                  <TableCell>Cliente (DPI)</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {results.map((tenencia, index) => (
                  <TableRow key={tenencia.id || index}>
                    <TableCell>{tenencia.serie}</TableCell>
                    <TableCell>{tenencia.dpi}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleDownload(tenencia.fileUrl, `${tenencia.serie}.pdf`)}
                        sx={{ marginRight: '10px' }}
                      >
                        Descargar
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleDelete(tenencia.id)}
                      >
                        Eliminar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Container>
  );
};

export default ImprimirTenencias;
